import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PushNotificationService } from 'src/app/shared/services/push-notification/push-notification.service';
import { AuthService } from 'src/app/shared/services/auth/auth.service';

@Component({
  selector: 'app-modal-notificacao-permissao',
  templateUrl: './modal-notificacao-permissao.component.html',
  styleUrls: ['./modal-notificacao-permissao.component.scss'],
})
export class ModalNotificacaoPermissaoComponent implements OnInit {
  showBrowserInstruction = false;
  errorMsg = '';
  isLoading = false;

  private readonly vapidPublicKey =
    'BJQz2kCZsQyAJUUPP9sraCdytNQS8223hkgFVDCIlLfkV8TWNlFEjNUPIlAzSKg-LDmkqOtuB3WvsIcaIWsynsE';

  constructor(
    public bsModalRef: BsModalRef,
    private _pushService: PushNotificationService,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {}

  async solicitarNotificacoes(): Promise<void> {
    try {
      if ('serviceWorker' in navigator && 'PushManager' in window) {
        const swReg = await navigator.serviceWorker.register(
          '/Home/service-worker.js',
        );

        let subscription = await swReg.pushManager.getSubscription();
        if (!subscription) {
          const permission = await Notification.requestPermission();
          if (permission === 'granted') {
            subscription = await swReg.pushManager.subscribe({
              userVisibleOnly: true,
              applicationServerKey: this.urlBase64ToUint8Array(
                this.vapidPublicKey,
              ) as BufferSource,
            });
          } else {
            this.bsModalRef.hide();
            return;
          }
        } else {
          console.log('Usuário já inscrito:', subscription);
        }
        const subJson = subscription.toJSON();
        const subPayload = {
          endpoint: subscription.endpoint,
          keys: {
            p256DH: subJson.keys['p256dh'],
            auth: subJson.keys['auth'],
          },
        };

        await this._pushService.subscribeToWebPush(subPayload).toPromise();
        this.showBrowserInstruction = true;
        localStorage.setItem('notificationPromptDismissed', 'true');
      } 
    } catch (error) {
      console.error('Erro solicitando permissão:', error);
    }
    this.bsModalRef.hide();
  }

  private urlBase64ToUint8Array(base64String: string): Uint8Array {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding)
      .replace(/-/g, '+')
      .replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }

  fecharModal(): void {
    const userId = this.authService.userID;
    const storageKey = userId ? `notificationPromptDismissed_${userId}` : 'notificationPromptDismissed';
    localStorage.setItem(storageKey, Date.now().toString());
    this.bsModalRef.hide();
  }

  static shouldShowModal(authService: AuthService): boolean {
    const userId = authService.userID;
    const storageKey = userId ? `notificationPromptDismissed_${userId}` : 'notificationPromptDismissed';
    const lastShown = localStorage.getItem(storageKey);

    if (!lastShown) {
      return true; 
    }

    const lastShownTime = parseInt(lastShown, 10);
    const oneWeekInMs = 7 * 24 * 60 * 60 * 1000;
    const now = Date.now();

    return (now - lastShownTime) > oneWeekInMs;
  }
}
